import Recommend from './Recommend';
import { getRecommendations } from 'common/utils/recommend';

export default Recommend;
export { getRecommendations };
